import React from 'react'
import Chip from '@mui/material/Chip'
import { REGISTRATION_STATUS } from '../labels'

const RegistrationStatusChip = ({ status, ...props }) => {
  const config = REGISTRATION_STATUS[status] || { label: status, color: 'default' }
  return (
    <Chip
      label={config.label}
      color={config.color}
      size="small"
      sx={{ borderRadius: 1, fontWeight: 700 }}
      {...props}
    />
  )
}

export default RegistrationStatusChip
